import { Component, ElementRef, Input, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { faCopy, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { ActivatedRoute } from "@angular/router";
import { QRCodeService, QRFormRequest } from 'src/app/services/settings/qrcode.service';
import { AsyncModalService } from 'src/app/services/shared/async-modal-service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    standalone: false,
    selector: 'app-qrcode-modal',
    templateUrl: './qrcode-modal.component.html',
    styleUrls: ['./qrcode-modal.component.css'],
    providers: [QRCodeService]
})
export class QRCodeModalComponent implements OnInit {
    @ViewChild("closeQRCodeModal")
    private closeQRCodeModal: ElementRef;

    isCreateTypeQRCode: boolean;
    qrCodeName: string;
    qrCodeEntryNumber: number;
    formEntryNumber: number;
    registerFormEntryNumber: number;
    projectId: number;
    projectName: string;
    formName: string;
    faCopyUse: IconDefinition = faCopy;
    qrCodeImage: any;
    qrCodeImageBase64: string;
    canCopy: boolean;
    canDownload: boolean;

    constructor(
        private route: ActivatedRoute,
        private qrCodeService: QRCodeService,
        private asyncModalService: AsyncModalService,
        private sanitizer: DomSanitizer
    ) {

    }

    ngOnInit(): void {
        this.qrCodeService.formArea = this.route.snapshot.data.formArea;
        this.qrCodeService.formEntryNumber = +this.route.snapshot.params.formId;
        this.canCopy = false;
        this.canDownload = false;
    }

    generateQRCode() {
        var qrFormRequest: QRFormRequest = new QRFormRequest;
        qrFormRequest.isCreateTypeQRCode = this.isCreateTypeQRCode;
        qrFormRequest.projectId = +(this.projectId);
        qrFormRequest.fcEntryNumber = this.qrCodeService.formEntryNumber;
        qrFormRequest.qrCodeEntryNumber = this.qrCodeEntryNumber;
        qrFormRequest.accessNbr = this.route.snapshot.data["accessNbr"];
        qrFormRequest.routeUrl = this.route.snapshot["_routerState"].url;
        qrFormRequest.isGlobal = this.route.snapshot.data.isGlobal;
        this.qrCodeImage = "/img/QRCode-Loader.gif";

        return new Promise((resolve, reject) => {
            this.qrCodeService.generateQRCode(qrFormRequest, this.formEntryNumber)
                .subscribe(
                    (data) => {
                        this.qrCodeImageBase64 = 'data:image/png;base64,' + data;
                        this.qrCodeImage = this.sanitizer.sanitize(
                            SecurityContext.HTML,
                            this.sanitizer.bypassSecurityTrustHtml(this.qrCodeImageBase64)
                        );
                        this.canCopy = true;
                        this.canDownload = true;
                        return resolve(true);
                    },
                    (err) => {
                        this.closeQRCodeModal.nativeElement.click();
                        this.asyncModalService.getModalResponse(err.error);
                        return reject(false);
                    }
                );
        });
    }

    download() {
        try {
            const blobData = this.convertBase64ToBlobData(this.qrCodeImageBase64);
            const blob = new Blob([blobData], { type: 'image/png' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download =
                this.projectName + " - " +
                this.formName + " - " +
                this.qrCodeName +
                (this.registerFormEntryNumber > 0 ? " #" + this.registerFormEntryNumber : "");
            link.click();
        }
        catch {
            this.asyncModalService.getModalResponse("Failed to Download QR Code");
        }
    }

    copy() {
        let el = document.createElement("img");
        el.src = this.qrCodeImageBase64
        document.body.appendChild(el);
        document.execCommand("copy");
        document.body.removeChild(el);

        this.asyncModalService.getModalResponse("Link copied to clipboard");
    }

    close() {
        this.canDownload = false;
    }


    private convertBase64ToBlobData(imageData: string, contentType: string = 'image/png', sliceSize = 512) {
        const byteCharacters = atob(imageData.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
